import { datadogRum } from '@datadog/browser-rum';
import { AlgoliaFacetsType } from '@src/clients/Algolia/constants';
import { GetMemberPlanQuery } from '@src/graphqlTypes/catalogServiceTypes';

export interface SearchReducerInterface {
	filters: string | null;
	employerUuid: string | null;
	facets: AlgoliaFacetsType | null;
	hasFacets: boolean;
	index: string;
	indexAvailable: boolean;
	isMemberServicesRoute: boolean;
	memberPlanData: GetMemberPlanQuery['memberPlan'] | null;
	memberUuid: string;
	planUuid: string | null;
	searchError: Error | null;
	staticTotalPrograms: number;
}

export type SearchActionTypes = {
	filters?: string;
	employerUuid?: string;
	facets?: AlgoliaFacetsType | null;
	hasFacets?: boolean;
	index?: string;
	indexAvailable?: boolean;
	isMemberServicesRoute?: boolean;
	memberPlanData?: GetMemberPlanQuery['memberPlan'] | null;
	memberUuid?: string;
	planUuid?: string;
	searchError?: Error | null;
	staticTotalPrograms?: number;
	type:
		| 'set_no_facets_returned'
		| 'set_no_plan_uuid_returned'
		| 'set_no_plan_programs_returned'
		| 'set_search_state'
		| 'set_search_state_error'
		| 'set_member_and_employer_uuids';
};

export const searchInitialState: SearchReducerInterface = {
	filters: null,
	employerUuid: null,
	facets: null,
	hasFacets: true,
	index: '',
	indexAvailable: true,
	isMemberServicesRoute: false,
	memberPlanData: null,
	memberUuid: '',
	planUuid: null,
	searchError: null,
	staticTotalPrograms: 0,
};

export const searchReducer = (state: SearchReducerInterface, action: SearchActionTypes) => {
	switch (action.type) {
		case 'set_no_facets_returned': {
			return {
				...state,
				facets: action.facets,
				hasFacets: action.hasFacets,
				indexAvailable: action.indexAvailable,
			};
		}
		case 'set_no_plan_uuid_returned': {
			return {
				...state,
				facets: action.facets,
				indexAvailable: action.indexAvailable,
			};
		}
		case 'set_no_plan_programs_returned': {
			return {
				...state,
				facets: action.facets,
				indexAvailable: action.indexAvailable,
			};
		}
		case 'set_search_state': {
			return {
				...state,
				filters: action.filters,
				employerUuid: action.employerUuid,
				facets: action.facets,
				index: action.index,
				indexAvailable: action.indexAvailable,
				isMemberServicesRoute: action.isMemberServicesRoute,
				memberPlanData: action.memberPlanData,
				memberUuid: action.memberUuid,
				planUuid: action.planUuid,
				staticTotalPrograms: action.staticTotalPrograms,
			};
		}
		case 'set_search_state_error': {
			return {
				...state,
				facets: action.facets,
				indexAvailable: action.indexAvailable,
				searchError: action.searchError,
			};
		}
		case 'set_member_and_employer_uuids': {
			return {
				...state,
				memberUuid: action.memberUuid,
				employerUuid: action.employerUuid,
			};
		}

		default:
			datadogRum.addError('Unknown action', {
				catalogReducerAction: `${action.type}`,
				catalogContext: 'searchReducer',
			});
			throw Error(`Unknown action: ${action.type}`);
	}
};
